module.exports = __webpack_public_path__ + "img/avt-40-3.95ada725.png";